import React, { useContext, VFC } from 'react'

import { ProductContext } from '@Components/Product/Context'
import { Breadcrumbs } from '@Components/Product/Display/Breadcrumbs'
import { ProductArticleWrapper } from '@Components/Product/Display/styledElements'
import { DisplayV1 } from '@Components/Product/Display/v1'
import DisplayV2 from '@Components/Product/Display/v2'
import { MetadataContext } from '@Globals/Metadata'
import { Experiment } from '@Globals/SplitTests/Experiment'

export const ProductDisplay: VFC = () => {
  const product = useContext(ProductContext)
  const { page: { breadcrumbs = [] } = {} } = useContext(MetadataContext)

  // TODO: This has to work better.
  if (!product) {
    return <>404</>
  }

  return (
    <ProductArticleWrapper hasBreadcrumbs={!!breadcrumbs && breadcrumbs.length > 0}>
      <Breadcrumbs />
      <Experiment
        A={<DisplayV1 />}
        B={<DisplayV2 />}
        C={(
          <>
            <DisplayV2 />
            <DisplayV1 />
          </>
        )}
        test="product_display_block_v1"
      />
    </ProductArticleWrapper>
  )
}
